<template>
    <form-row title="Has the power of attorney been received?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="has_received_power_of_attorney"
                v-model="has_received_power_of_attorney"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="has_received_power_of_attorney"
            class="mt-4 sm:ml-12 sm:-mt-2 sm:-mb-2 flex flex-1 items-center sm:justify-end"
                label="Date Received:"
                :value="attorney.received_power_of_attorney_at"
                name="received_power_of_attorney_at"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        attorney: {},
        read_only: { default: false },
    },

    data() {
        return {
            has_received_power_of_attorney: this.attorney.has_received_power_of_attorney,
        }
    },
}
</script>
